/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getOrderList, getproductDetails } from '@/api';
export default {
  name: 'myOrder',
  data: function data() {
    return {
      classificationData: [],
      value: '',
      active: 0,
      orderTabs: [{
        order_type: 0,
        name: i18n.tc("67")
      }, {
        order_type: 1,
        name: i18n.tc("642")
      }, {
        order_type: 3,
        name: i18n.tc("644")
      }, {
        order_type: 4,
        name: i18n.tc("562")
      }],
      orderStatu: [{
        order_type: 1,
        name: i18n.tc("642")
      }, {
        order_type: 2,
        name: i18n.tc("643")
      }, {
        order_type: 3,
        name: i18n.tc("644")
      }, {
        order_type: 4,
        name: i18n.tc("562")
      }, {
        order_type: 5,
        name: i18n.tc("389")
      }, {
        order_type: 6,
        name: i18n.tc("66")
      }, {
        order_type: 0,
        name: i18n.tc("646")
      }],
      orderClassification: {
        customer_name: '',
        linkperson: '',
        linkperson_phone: '',
        order_type: 0,
        pageIndex: 0,
        pageSize: 10
      },
      id: this.$route.params.id,
      isShow: false,
      loading: false,
      isUpLoading: false,
      // 上拉加载
      upFinished: false,
      // 上拉加载完毕
      offset: 100 // 滚动
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;
      getOrderList(_objectSpread(_objectSpread({}, this.orderClassification), {}, {
        keyword: this.value
      })).then(function (res) {
        if (res.success) {
          if (res.data == null || res.data.length < 1) {
            _this.upFinished = true; // 加载结束
            _this.classificationData = res.data;
            return;
          }
          if (res.data.length < _this.orderClassification.pageSize) {
            _this.upFinished = true; // 最后一页不足10条的情况
          }
          if (_this.orderClassification.pageIndex === 0) {
            _this.classificationData = res.data;
          } else {
            _this.classificationData = _this.classificationData.concat(res.data);
          }
        }
      });
    },
    onClickTab: function onClickTab() {
      this.orderClassification.pageIndex = 0;
      if (this.active == 1) {
        this.orderClassification.order_type = 1;
      } else if (this.active == 2) {
        this.orderClassification.order_type = 3;
      } else if (this.active == 3) {
        this.orderClassification.order_type = 4;
      } else {
        this.active = 0;
        this.orderClassification.order_type = 0;
      }
      this.getData();
    },
    goDetail: function goDetail(item) {
      this.$router.push({
        name: 'orderDetails',
        params: {
          id: item.fk_t_shop_order_id
        }
      });
      // this.$router.push(`/serviceMall/myOrder/${item.fk_t_shop_order_id}`, { params: { id: item.fk_t_shop_order_id } })
    },
    goBook: function goBook(item) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getproductDetails({
                  fk_t_shop_goods_id: item.fk_t_shop_goods_id
                });
              case 2:
                res = _context.sent;
                if (res.success) {
                  _this2.$router.push({
                    name: 'Appointment',
                    query: {
                      id: res.data.object_id,
                      shopId: item.id,
                      shopOrderId: item.orderId
                    }
                  });
                } else {
                  _this2.$vux.toast.text(res.message || i18n.tc("647"));
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onRefresh: function onRefresh() {
      var _this3 = this;
      setTimeout(function () {
        _this3.getData();
        _this3.$vux.toast.text(i18n.tc("641"));
        _this3.loading = false;
        _this3.upFinished = false;
      }, 1000);
    },
    onLoadList: function onLoadList() {
      this.orderClassification.pageIndex++;
      this.getData();
    }
  },
  computed: {},
  created: function created() {
    var _this$$route$params, _this$$route$params$s;
    if ((_this$$route$params = this.$route.params) !== null && _this$$route$params !== void 0 && (_this$$route$params$s = _this$$route$params.state) !== null && _this$$route$params$s !== void 0 && _this$$route$params$s.order_type) {
      var stateNum = this.$route.params.state.order_type;
      if (stateNum == 1) {
        this.active = 1;
        this.orderClassification.order_type = 1;
      } else if (stateNum == 2) {
        this.orderClassification.order_type = 3;
      } else if (stateNum == 3) {
        this.active = 2;
        this.orderClassification.order_type = 3;
      } else if (stateNum == 4) {
        this.active = 3;
        this.orderClassification.order_type = 4;
      } else {
        this.orderClassification.order_type = 0;
      }
    } else {
      this.active = 0;
      this.orderClassification.order_type = 0;
    }
    this.getData();
  },
  mounted: function mounted() {
    this.getData();
  }
};